import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { applyJob, withdrawJob } from '../../Redux/Actions/jobBoard'
import { useNavigate } from 'react-router-dom'
import share from '../../Assets/svg/share.svg'
import fb from '../../Assets/svg/fb.svg'
import whatsapp from '../../Assets/svg/whatsapp.svg'
import copyLink from '../../Assets/svg/copy_link.svg'
import User from '../../Assets/svg/user.svg'
import Building from '../../Assets/svg/building.svg'
import avatar from '../../Assets/images/avatar.jpeg'
import schoolLogo from '../../Assets/images/school-logo.jpeg'

const text = [
  "The recruiter has released the shortlist for this role. Please check the list to see if you’ve been shortlisted. All the best!",
  "The company has chosen to keep the shortlist private. Our team will reach out to shortlisted students or their college placement offices.",
  "The recruiter is still reviewing applications. The shortlist will be shared once the review process is completed."
]
const statusText = [
  "This role is actively accepting applications and the recruiter is currently reviewing incoming profiles.",
  "Applications are paused as enough candidates are being reviewed or the recruiter is taking time to proceed.",
  "The position has been filled and is no longer accepting applications."
]
const JobCard = ({ nologo, screening, withdrawApplication, item, onCardClick }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const kids = useSelector((state) => state.dashboard.kids)
  const resumeData = useSelector((s) => s.ProfileSteps.submissionData)
  const data = useSelector((s) => s.ProfileSteps.introData)
  const profileData = useSelector((s) => s.ProfileSteps.profileData)
  const [copySuccess, setCopySuccess] = useState(false)

  const [applicationStatus, setApplicationStatus] = useState(item?.application_status)
  const isProfileComplete = resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl && data?.length > 0 && profileData?.user_name

  const handleApply = (e) => {
    e.stopPropagation()
    setApplicationStatus('APPLICATION_SENT')
    dispatch(applyJob({ job_id: item?.job_id, kid_id: kids[0]?.id }))
  }

  const handleApplyClick = (e) => {
    e.stopPropagation()
    if (isProfileComplete) {
      handleApply(e)
    }
  }

  const handleWithdraw = (e) => {
    e.stopPropagation()
    setApplicationStatus('WITHDRAWN')
    dispatch(withdrawJob({ job_id: item?.job_id, kid_id: kids[0]?.id }))
  }

  const handleModalOpen = (e) => {
    e.stopPropagation()
  }

  const handleCardClick = () => {
    if (onCardClick) {
      onCardClick()
    }
  }

  const modalId = `withdrawModal_${item?.job_id}`
  const shortlistModalId = `shortlistModal_${item?.job_id}`
  const applymodalId = `applyModal_${item?.job_id}`
  const getShareUrl = () => {
    return `${window.location.origin}/job-detail?id=${item?.job_unique_id}`
  }
  const handleCopyLink = async () => {
    try {
      const fullUrl = getShareUrl()
      await navigator.clipboard.writeText(fullUrl)
      setCopySuccess(true)
      setTimeout(() => setCopySuccess(false), 2000)
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }
  const formatCTC = (value) => {
    if (!value && value !== 0) return ''

    const num = Number(value)

    if (num >= 100000) {
      return `${num / 100000} lpa`
    }

    return `${num / 1000} k`
  }

  const handleWhatsAppShare = () => {
    const url = getShareUrl()
    // const text = encodeURIComponent(`${item?.company_name} | ${item?.job_title} | ${item?.ctc} - View the job details and apply directly here: ${url}`);
    const text = encodeURIComponent(`${item?.company_name} | ${item?.job_title} | ${formatCTC(item?.ctc)} - View the job details and apply directly here: ${url}`)

    if (/Android|iPhone/i.test(navigator.userAgent)) {
      window.open(`whatsapp://send?text=${text}`, '_blank')
    } else {
      window.open(`https://wa.me/?text=${text}`, '_blank')
    }
  }

  const handleFacebookShare = () => {
    const url = getShareUrl()
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
    window.open(facebookUrl, '_blank', 'width=600,height=400')
  }
  
  return (
    <>
      <div className={`job-card ${nologo}`} onClick={handleCardClick}>
        <div className="position-relative">
          <div className="job-card-header">
            <img src={item?.company_logo_url} alt="" />
            <h2>{item?.company_name}</h2>
          </div>
          <div className={`card-info-status ${item?.job_status == "LIVE" ? "open" : "closed"}`}>
            {item?.job_status}
            <span data-bs-toggle="tooltip" data-bs-placement="top" title={`${item?.job_status == "LIVE" ? statusText[0] : item?.job_status == "ONHOLD" ? statusText[1] : statusText[2]}`}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_3321_4466)">
                <path d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z" stroke="#1B3867" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 9H12.01" stroke="#1B3867" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11 12H12V16H13" stroke="#1B3867" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                <clipPath id="clip0_3321_4466">
                <rect width="24" height="24" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </span>
          </div>
          <div
            className="dropdown share-dropdown position-absolute end-0 top-0"
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <button type="button" className="default-btn no-after bg-transparent border-0 dropdown-toggle" id="dropdownMenuButton123" data-bs-toggle="dropdown" aria-expanded="false">
              <img src={share} alt="Share icon" />
              Share
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton123">
              <li className="dropdown-item">
                <span onClick={handleCopyLink} style={{ cursor: 'pointer' }}>
                  <img src={copyLink} alt="Copy link icon" />
                  {copySuccess ? 'Copied!' : 'Copy Link'}
                </span>
              </li>
              <li className="dropdown-item">
                <span onClick={handleWhatsAppShare} style={{ cursor: 'pointer' }}>
                  <img src={whatsapp} alt="WhatsApp icon" />
                  WhatsApp
                </span>
              </li>
              {/* <li className="dropdown-item">
              <span onClick={handleFacebookShare} style={{ cursor: 'pointer' }}>
                <img src={fb} alt="Facebook icon" />
                Facebook
              </span>
            </li>  */}
            </ul>
          </div>
        </div>
        <div className="job-card-body pt-4">
          <ul className="job-card-feature-list">
            {item?.job_title && (
              <li className="fw-bold">
                <img src="./svg/sdm.svg" alt="" />
                {item?.job_title}
              </li>
            )}
            {item?.job_department && (
              <li>
                <img src="./svg/soe.svg" alt="" />
                {item?.job_department}
              </li>
            )}
            {item?.job_location && (
              <li>
                <img src="./svg/location.svg" alt="" />
                {item?.job_location}
              </li>
            )}
          </ul>
          <div className={`screening-sec ${screening}`} onClick={(e) => e.stopPropagation()}>
            <h2>This job requires Proof of Skill</h2>
            <button type="button" className="default-btn blue-border-btn position-static">
              Add Screening Criteria
            </button>
          </div>
          <div className="card-tags-main">
            {item?.application_last_date && (
              <div className="card-tags">
                Apply by :{' '}
                {new Date(item?.application_last_date).toLocaleDateString('en-GB', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric',
                })}
              </div>
            )}
            {item?.ctc && (
              <div className="card-tags">
                <span className="fw-semibold">{`${item?.job_type == 'FULLTIME' ? 'CTC' : 'Stipend'}`} : </span> ₹{(item?.ctc || 0).toLocaleString('en-IN')}
              </div>
            )}
            {/* <button className="p-2" data-bs-toggle="modal" data-bs-target={`#${shortlistModalId}`} onClick={handleModalOpen}>view shortlist</button> */}
          </div>
          <div class="job-card-btn">
            <button className={`default-btn card-status-btn ${item?.shortlist_status == "Shortlist Awaited" ? "shortlist-awaited" : item?.shortlist_status == "Shortlist Withheld" ? "shortlist-withheld" : "shortlisted"} mb-2`} disabled={item?.shortlist_status === "Shortlist Awaited"}  
            // style={{
            //   opacity: item?.shortlist_status !== "Shortlist Awaited" ? 1 : 0.5,
            //   cursor: item?.shortlist_status !== "Shortlist Awaited"? 'pointer' : 'not-allowed',
            // }} 
            data-bs-toggle="modal" data-bs-target={`#${shortlistModalId}`} onClick={(e) => e.stopPropagation()}>
                {item?.shortlist_status}
                 <span className='' title={`${item?.shortlist_status == "Shortlist Awaited" ? text[2] : item?.shortlist_status == "Shortlist Withheld" ? text[1] : text[0]}`}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_3321_4466)">
                    <path d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z" stroke="#1B3867" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 9H12.01" stroke="#1B3867" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11 12H12V16H13" stroke="#1B3867" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_3321_4466">
                    <rect width="24" height="24" fill="white"/>
                    </clipPath>
                    </defs>
                  </svg>
                </span>
            </button>
            {item?.application_status === 'APPLICATION_SENT' ? (
              <button className="default-btn blue-border-btn" disabled={item?.job_status == 'CLOSED'}  style={{
              opacity: item?.job_status !== 'CLOSED' ? 1 : 0.5,
              cursor: item?.job_status !== 'CLOSED'? 'pointer' : 'not-allowed',
            }} data-bs-toggle="modal" data-bs-target={`#${modalId}`} onClick={handleModalOpen}>
                Withdraw Application
              </button>
            ) : (
              <button
                className={`default-btn ${screening}`}
                {...(!isProfileComplete && {
                  'data-bs-toggle': 'modal',
                  'data-bs-target': `#${applymodalId}`,
                })}
                onClick={handleApplyClick}
                disabled={item?.job_status !== 'LIVE'}
                 style={{
              opacity: item?.job_status == 'LIVE' ? 1 : 0.5,
              cursor: item?.job_status == 'LIVE'? 'pointer' : 'not-allowed',
            }}
              >
                Apply Now
              </button>
            )}
          </div>
        </div>
<div
          className="modal fade common-modal"
          id={shortlistModalId}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby={`${shortlistModalId}Label`}
          aria-hidden="true"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-dialog modal-xl p-0 p-lg-4">
            <div className="modal-content border-0">
              <div className="modal-body text-center">
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                {item?.selected_candidates.length > 0 && (
                    <>
                  <h2 className='popup-title mb-3 text-center'>Selected Candidates ({item?.selected_candidates.length})</h2>
                  <div className="row mx-0 mt-lg-5">
                    {item?.selected_candidates.map((candidate, index) => (    
                    <div className="col-md-3 mb-3 mb-lg-4">
                      <div className="user-card p-4">
                        <div className="candidate-avatar">
                            <img src={candidate?.student_profile_img ? candidate?.student_profile_img : User} alt="" />
                            <span className='school-logo'><img src={candidate?.college_logo} /></span>
                        </div>
                        <ul className='list'>
                          <li>
                            <img src={User} alt="" />
                            {candidate?.student_name}
                          </li>
                          <li>
                            <img src={Building} alt="" />
                            {candidate?.college_name}
                          </li>
                        </ul>
                      </div>
                    </div>
                    ))}
                  </div>
                  </>)}
                  {item?.shortlisted_candidates.length > 0 && (
                    <>
                  {item?.selected_candidates.length > 0 && <hr className='my-3 my-lg-5'/> }
                  <h2 className='popup-title mb-0 text-center'>Shortlisted Candidates ({item?.shortlisted_candidates.length})</h2>
                  <div className="row mx-0 mt-4">
                    {item?.shortlisted_candidates.map((candidate, index) => (    
                    <div className="col-md-3 mb-3 mb-lg-4">
                      <div className="user-card p-4">
                        <div className="candidate-avatar">
                            <img src={candidate?.student_profile_img ? candidate?.student_profile_img : User} alt="" />
                            <span className='school-logo'><img src={candidate?.college_logo} /></span>
                        </div>
                        <ul className='list'>
                          <li>
                            <img src={User} alt="" />
                            {candidate?.student_name}
                          </li>
                          <li>
                            <img src={Building} alt="" />
                            {candidate?.college_name}
                          </li>
                        </ul>
                      </div>
                    </div>
                    ))}
                  </div>
</>)}
              </div>
            </div>
          </div>
        </div>

        {/* Withdraw Modal */}
        <div 
          className="modal fade common-modal" 
          id={modalId}
          data-bs-backdrop="static" 
          data-bs-keyboard="false" 
          tabIndex="-1" 
          aria-labelledby={`${modalId}Label`}
          aria-hidden="true"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content border-0">
              <div className="modal-body text-center px-3 px-lg-5">
                <button 
                  type="button" 
                  className="btn-close" 
                  data-bs-dismiss="modal" 
                  aria-label="Close"
                ></button>
                <h2 className='popup-title mb-3'>Withdraw Application</h2>
                <p className='mb-4'>
                  Are you sure you want to withdraw your application for {item?.job_title} at {item?.company_name}?
                </p>
                <button 
                  type="button" 
                  onClick={handleWithdraw} 
                  data-bs-dismiss="modal" 
                  className="default-btn w-100 mb-3"
                >
                  Yes, Withdraw
                </button>
                <button 
                  type="button" 
                  className="default-btn blue-border-btn w-100" 
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Apply Modal */}
        <div
          className="modal fade common-modal"
          id={applymodalId}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby={`${applymodalId}Label`}
          aria-hidden="true"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content border-0">
              <div className="modal-body text-center px-3 px-lg-5">
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <h2 className="popup-title mb-3">Update your Profile</h2>
                <p className="mb-4">
                  Upload your <strong>resume</strong> and add a 1-2 minute <strong>introduction video</strong> to unlock job applications and increase your chances of selection.
                </p>
                <button type="button" onClick={() => navigate('/profile')} data-bs-dismiss="modal" className="default-btn w-100 mb-3">
                  Update Profile
                </button>
                <button type="button" className="default-btn blue-border-btn w-100" data-bs-dismiss="modal">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default JobCard
